export const textToHtml = (text: string): string =>
  typeof text === 'string'
    ? text.split('\n').join('<br>')
    : '';
